import React, { useEffect, useMemo, useRef, useState } from "react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";

import CurrentMonthSummaryRawData from "./CurrentMonthSummaryRawData";
import { currentSummaryColDef } from "./currentSummaryColDef";

import { Alert, Box, Button, Fade, Snackbar } from "@mui/material";
import "../ag-table.css";

import dayjs from "dayjs";
import { useModalContext } from "../ModalContext";
import AddNewScheme from "../components/AddNewScheme";
import BasicSelect from "../components/BasicSelect";
import LoadingSpinner from "../components/LoadingSpinner";
import MonthYearPicker from "../components/MothYearPicker";
import { TYPES } from "../constants";
import EditModal from "./EditModal";
import { roundData } from "../helpers/currentMonthSummaryData";
import AlertModal from "../components/AlertModal";
import api from "../axiosConfig";
import { getDatesFromMonthYearAsia } from "../helpers";
import { fetchEditPermissions } from "../api/editpermissions";
import AddNewProductModal from "../components/AddNewProductModal";
import AddNewForecasting from "../components/AddNewForecasting";
import CreateSchemeMultiWarehouse from "./CreateSchemeMultiWarehouse";

// icons
import AddIcon from "@mui/icons-material/Add";
import ClearFilterBtn from "../components/ClearFilterBtn";

const CurrentMonthSummary = ({ open }) => {
  const {
    customOpenModal,
    setCustomOpenModal,
    mode,
    closeModal,
    editingValue,
    openModalWithAGValues02,
    newSchemeModalOpen,
    setNewSchemeModalOpen,
    alertModalOpen,
    setAlertModalOpen,
    lineDataClick,
    setSaveLoading,
    currency,
    hasActiveFilters,
    setHasActiveFilters,
  } = useModalContext();
  const [monthYear, setMonthYear] = useState(dayjs());
  const [type, setType] = useState(TYPES[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [editValue, setEditValue] = useState();
  const [callValue, setCallValue] = useState(null);
  const [rowIndex, setRowIndex] = useState();
  const [loadingButton, setLoadingButton] = useState();
  const [schemeContinue, setSchemeContinue] = useState(false);
  const { loading, data: rowData } = CurrentMonthSummaryRawData(
    monthYear,
    type,
    currency
  );
  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(currentSummaryColDef(monthYear, type));
  }, [monthYear, type]);
  const [rowColumn, setRowColumn] = useState();
  const [schemeTypeData, setSchemeTypeData] = useState(false);
  const [baselineRateValue, setBaselineRateValue] = useState(0);
  const [initialCorrectionValue, setInitialCorrectionValue] = useState(null);
  const [currentCorrectionValue, setCurrentCorrectionValue] = useState(null);
  const [initialTotalValue, setInitialTotalValue] = useState(null);
  const [currentTotalValue, setCurrentTotalValue] = useState(null);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [loadingRowType, setLoadingRowType] = useState(null);
  const [snackbarAlertOpen, setSnackbarAlertOpen] = useState(false);
  const [snackbarAlertMessage, setSnackbarAlertMessage] = useState("");
  const [SnackbarAlertSeverity, setSnackbarAlertSeverity] = useState("success");
  // const [selectedSchemeType, setSelectedSchemeType] = useState(false);
  const [allLeafChildren, setAllLeafChildrens] = useState([]);

  const [modalformData, modalsetFormData] = useState({
    schemeName: "",
    schemeStartDate: null,
    schemeEndDate: null,
    warehouse: [],
    channel: [],
    pricelist: [],
    productName: [],
    product: [],
    schemeType: "",
    rateImpact: "",
    quantityImpact: "",
    schemeImpactValue: "",
  });

  const clearModalFormData = () => {
    modalsetFormData((prevData) => ({
      ...prevData,
      rateImpact: "",
      quantityImpact: "",
      schemeImpactValue: "",
    }));
  };

  // const handleUpdate = () => {
  //   // Handle the button click and perform any update logic
  //   console.log("Updated", currentCorrectionValue);
  // };

  // const handleOpenModal = (rowData) => {
  //   console.log(callValue.btg_correction, "callValue.btg_correction");
  //   if (!callValue.btg_correction) {
  //     setSchemeTypeData(rowData);
  //     setNewSchemeModalOpen(true);
  //   } else {
  //     // alert("You can't create new scheme for this product");
  //     setAlertModalOpen(true);
  //   }
  // };

  const handleOpenModal = (rowData) => {
    const correctionEntry = editValue.find(
      (entry) => entry.Request_Type === "Correction"
    );

    // if (correctionEntry && parseFloat(correctionEntry.Sales) > 0) {
    //   // If Correction Sales value exists, show alert modal
    //   setAlertModalOpen(true);
    //   setSchemeTypeData(rowData);
    // } else {
    //   // If no Correction Sales value, proceed with scheme setup
    //   setSchemeTypeData(rowData);
    //   setNewSchemeModalOpen(true);
    // }

    setSchemeTypeData(rowData);
    setNewSchemeModalOpen(true);
  };

  const handleOpenContinueModal = (params) => {
    setUpdateLoading(true);
    setSaveLoading(true);

    const payload = {
      ...lineDataClick,
      schemeType: params?.type,
      page: "summary",
    };
    api
      .post("/api/scheme/continues ", {
        body: payload,
      })
      .then((response) => {
        if (response.data.Status) {
          let requestType = {
            "On Invoice": "OnInv",
            "Off Invoice": "OffInv",
            Visibility: "Visibility",
          };
          setSchemeTypeData({
            ...response.data[0],
            type: params?.type,
          });
          setEditValue(
            response.data.Data.map((item) => ({
              ...item,
              Request_Type: requestType[params?.type],
            }))
          );
          setCustomOpenModal(false);
          setNewSchemeModalOpen(true);
        } else {
          setSnackbarAlertSeverity("error");
          setSnackbarAlertOpen(true);
          setSnackbarAlertMessage("No scheme to continue");
          setCustomOpenModal(true);
          setNewSchemeModalOpen(false);
        }
        setSaveLoading(false);
        // setCustomOpenModal(true);
        // setLoading(false);
      })
      .catch((error) => {
        console.error("Error scheme continue:", error);
        setSnackbarAlertMessage("Failed to scheme continue");
        setSnackbarAlertSeverity("error");
        setSnackbarAlertOpen(true);
        setSaveLoading(false);
        setCustomOpenModal(true);
      })
      .finally(() => {
        setUpdateLoading(false);
        // if (shouldOpenNewSchemeModal) {
        setSchemeContinue(true);
        // }
      });
  };

  const sideBar = {
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        toolPanelParams: {
          suppressPivotMode: true,
          suppressPivots: true, //Hide column label
        },
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ],
    defaultToolPanel: "",
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 120,
      width: 120,
      pinned: "left",
      filter: "agGroupColumnFilter",
      cellRendererParams: {
        totalValueGetter: (params) => {
          const isRootLevel = params.node.level === -1;
          if (isRootLevel) {
            return "Grand Total";
          }
          return `Sub Total (${params.value})`;
        },
        suppressCount: true,
      },
    };
  }, []);

  const gridRef = useRef(null);

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  // Update filter state whenever filters change.
  const onFilterChanged = (params) => {
    const currentFilters = params.api.getFilterModel();
    const isAnyFilterActive = Object.keys(currentFilters).length > 0;
    setHasActiveFilters(isAnyFilterActive);
  };
  const handleOpenNewTab = (params) => {
    const pricelist = rowColumn?.includes("Pricelist") ? params?.Pricelist : "";
    const OutletType = rowColumn?.includes("OutletType") ? params?.OutletType : "";
    const ProductCode = rowColumn?.includes("Product_Name") ? params?.ProductCode : "";
    //console.log("handleOpenNewTab",params,OutletType,ProductCode,rowColumn)
    const filterUrl = `Warehouse=${params?.Warehouse}&Channel=${OutletType}&Pricelist=${pricelist}&ProductCode='${ProductCode}'&monthYear=${monthYear}`;
    // Encode using Base64
    const base64EncodedUrl = btoa(filterUrl);
    // console.log(base64EncodedUrl, "Base64 Encoded URL");

    // Open in a new tab with the Base64-encoded URL
    window.open(`/current-month?encodedFilters=${base64EncodedUrl}`, "_blank");
  };

  const handleOpenNewTabChannel = (params) => {
    const pricelist = rowColumn?.includes("Pricelist") ? params?.Pricelist : "";

    const filterUrl = `Warehouse=${params?.Warehouse}&Channel=''&Pricelist=''&ProductCode=''&monthYear=${monthYear}`;
    // Encode using Base64
    const base64EncodedUrl = btoa(filterUrl);
    // console.log(base64EncodedUrl, "Base64 Encoded URL");

    // Open in a new tab with the Base64-encoded URL
    window.open(`/current-month-channel?encodedFilters=${base64EncodedUrl}`, "_blank");
  };
    const handleOpenNewTabPricelistProduct = (params) => {
    const pricelist = rowColumn?.includes("Pricelist") ? params?.Pricelist : "";

    const filterUrl = `Warehouse=&Channel=&Pricelist=${pricelist}&ProductCode=${params?.ProductCode}&monthYear=${monthYear}`;
    //console.log(filterUrl,rowColumn,params)
    // Encode using Base64
    const base64EncodedUrl = btoa(filterUrl);
    // console.log(base64EncodedUrl, "Base64 Encoded URL");

    // Open in a new tab with the Base64-encoded URL
    window.open(`/current-month?encodedFilters=${base64EncodedUrl}`, "_blank");
  };

    const handleOpenNewTabPricelistProductMonth = (params) => {
      // Determine if selected month is current month
      const today = dayjs();
      const isCurrentMonth = monthYear.isSame(today, 'month') && monthYear.isSame(today, 'year');
      let schemeStartDate, schemeEndDate;
      if (isCurrentMonth) {
        schemeStartDate = today.add(2, 'day').format('YYYY-MM-DD');
        schemeEndDate = monthYear.endOf('month').format('YYYY-MM-DD');
      } else {
        schemeStartDate = monthYear.startOf('month').format('YYYY-MM-DD');
        schemeEndDate = monthYear.endOf('month').format('YYYY-MM-DD');
      }
      setMultiModalFormData({
        schemeName: params?.SchemeName || "",
        schemeStartDate,
        schemeEndDate,
        warehouse: params?.Warehouse ? [params.Warehouse] : [],
        channel: [params?.OutletType || ""],
        pricelist: [params?.Pricelist || ""],
        productName: [params?.Product_Name || ""] ,
        productCode: [params?.ProductCode || "" ], // keep product codes in sync
        schemeType: params?.Scheme_Type || "",
        rateImpact: params?.Rate_Impact || "",
        quantityImpact: params?.Qty_Impact || "",
        schemeImpactValue: params?.Sales || "",
        mrpRate: params?.mrpRate || "",
      });
      setMultiModalHeader("Create Multi-Warehouse Scheme");
      setMultiModalType("multi");
      setIsSchemeMultiModalOpen(true);
      setSelectedChannel([params?.OutletType || ""]);
      setSelectedProduct([params?.Product_Name || ""]);
      setSelectedCategory([params?.Pricelist || ""]);

      console.log("Model set ",multiModalFormData)
    };

    const handleOpenNewTabWarehouseSKUChannel= (params) => {
       setEditValue(null);
       setCallValue(null);

      const clickedRowDataProductCode02 = params?.node?.allLeafChildren["0"]?.data
      const RowColumns = params?.node?.id;
      setCallValue(params?.node?.allLeafChildren["0"]?.data);
      openModalWithAGValues02(
        clickedRowDataProductCode02,
        getCurrentMonthDatesAsia(monthYear),
        setEditValue,
        RowColumns,
        "",
        "summary"
      );

      setCustomOpenModal(true);

    }

    const handleOpenNewTabEditWarehouseChannelProductDay = (params) => {
    //console.log(params);
    const pricelist = ""//rowColumn?.includes("Pricelist") ? params?.Pricelist : "";

    //const filterUrl = `Warehouse=${params?.Warehouse}&Channel=${params?.OutletType}&Pricelist=''&ProductCode=''&monthYear=${monthYear}`;
    const filterUrl = `Warehouse=${params?.Warehouse}&Channel=${params?.OutletType}&Pricelist=${pricelist}&ProductCode=${params?.ProductCode}&monthYear=${monthYear}`;
    // console.log(filterUrl);
    // console.log("Call Value", params);
    // Encode using Base64
    const base64EncodedUrl = btoa(filterUrl);
    // console.log(base64EncodedUrl, "Base64 Encoded URL");

    // Open in a new tab with the Base64-encoded URL
    window.open(`/current-month?encodedFilters=${base64EncodedUrl}`, "_blank");
  };

  const handleOpenNewTabEditWarehouseChannelPricelistProductDay = (params) => {
    console.log("handleOpenNewTabEditWarehouseChannelPricelistProductDay",params);
    const pricelist = rowColumn?.includes("Pricelist") ? params?.Pricelist : "";

    //const filterUrl = `Warehouse=${params?.Warehouse}&Channel=${params?.OutletType}&Pricelist=''&ProductCode=''&monthYear=${monthYear}`;
    const filterUrl = `Warehouse=${params?.Warehouse}&Channel=${params?.OutletType}&Pricelist=${pricelist}&ProductCode=${params?.ProductCode}&monthYear=${monthYear}`;
    // console.log(filterUrl);
    // console.log("Call Value", params);
    // Encode using Base64
    const base64EncodedUrl = btoa(filterUrl);
    // console.log(base64EncodedUrl, "Base64 Encoded URL");

    // Open in a new tab with the Base64-encoded URL
    window.open(`/current-month?encodedFilters=${base64EncodedUrl}`, "_blank");
  };


  const getContextMenuItems = (params) => {
    const defaultItems = [
      "cut",
      "copy",
      "copyWithHeaders",
      "copyWithGroupHeaders",
      "paste",
      "export",
    ];

    const customItems = [
      {
        name: "Edit Day",
        action: (params) => {
          const clickedRowDataProductCode02 =
            params?.node?.allLeafChildren["0"]?.data;
            //console.log("customitems",params)
            setRowColumn(params?.node?.id)
          //console.log(clickedRowDataProductCode02);
          setCallValue(clickedRowDataProductCode02);
          handleOpenNewTab(clickedRowDataProductCode02);
          //setCustomOpenModal(true);
        },
        icon: '<i class="fa fa-edit"></i>',
      },
    ];
    const CustomItemsWarehouse=[
      {
        name: "Edit Day",
        action: (params) => {
          const clickedRowDataProductCode02 =
            params?.node?.allLeafChildren["0"]?.data;
          
          setCallValue(clickedRowDataProductCode02);
          handleOpenNewTabChannel(clickedRowDataProductCode02);
          //setCustomOpenModal(true);
        },
        icon: '<i class="fa fa-edit"></i>',
      },
    ];
    const CustomItemsPricelistSKU=[
      {
        name: "Edit Day",
        action: (params) => {
          const clickedRowDataProductCode02 =
            params?.node?.allLeafChildren["0"]?.data;
          setRowColumn(params?.node?.id)
          console.log(params)
          setCallValue(clickedRowDataProductCode02);
          handleOpenNewTabPricelistProduct(clickedRowDataProductCode02);
          //setCustomOpenModal(true);
        },
        icon: '<i class="fa fa-edit"></i>',
      },
      {
        name: "Edit Month",
        action: (params) => {
          const clickedRowDataProductCode02 =
            params?.node?.allLeafChildren["0"]?.data;
          //console.log(clickedRowDataProductCode02)
          setRowColumn(params?.node?.id)
          setRowIndex(params?.node?.allLeafChildren["0"]?.sourceRowIndex);
          setAllLeafChildrens(params?.node?.allLeafChildren);
          // console.log("Pricelist + SKU",params?.node?.allLeafChildren["0"]?.sourceRowIndex)
          handleOpenNewTabPricelistProductMonth(clickedRowDataProductCode02)
          setCallValue(clickedRowDataProductCode02);
          //handleOpenNewTabChannel(clickedRowDataProductCode02);
          //setCustomOpenModal(true);
        },
        icon: '<i class="fa fa-edit"></i>',
      },
    ];
    const CustomItemsWarehouseChannelSKU=[
      {
        name: "Edit Month",
        action: (params) => {
          const clickedRowDataProductCode02 =
            params?.node?.allLeafChildren["0"]?.data;
          console.log("Edit MOnth ",clickedRowDataProductCode02)
          setRowColumn(params?.node?.id);
          setRowIndex(params?.node?.allLeafChildren["0"]?.sourceRowIndex);
          setCallValue(clickedRowDataProductCode02);
          handleOpenNewTabWarehouseSKUChannel(params);
          //setCustomOpenModal(true);
        },
        icon: '<i class="fa fa-edit"></i>',
      },
      {
        name: "Edit Day",
        action: (params) => {
          const clickedRowDataProductCode02 =
            params?.node?.allLeafChildren["0"]?.data;
          
          setCallValue(clickedRowDataProductCode02);
          handleOpenNewTabEditWarehouseChannelProductDay(clickedRowDataProductCode02);
          //setCustomOpenModal(true);
        },
        icon: '<i class="fa fa-edit"></i>',
      },
    ];

        const CustomItemsWarehouseChannelPricelistSKU=[
      {
        name: "Edit Month",
        action: (params) => {
          const clickedRowDataProductCode02 =
            params?.node?.allLeafChildren["0"]?.data;
          console.log("Edit MOnth ",params)
          setRowColumn(params?.node?.id);
          setRowIndex(params?.node?.allLeafChildren["0"]?.sourceRowIndex);
          setCallValue(clickedRowDataProductCode02);
          handleOpenNewTabWarehouseSKUChannel(params);
          //setCustomOpenModal(true);
        },
        icon: '<i class="fa fa-edit"></i>',
      },
      {
        name: "Edit Day",
        action: (params) => {
          const clickedRowDataProductCode02 =
            params?.node?.allLeafChildren["0"]?.data;
          
          setCallValue(clickedRowDataProductCode02);
          handleOpenNewTabEditWarehouseChannelPricelistProductDay(clickedRowDataProductCode02);
          //setCustomOpenModal(true);
        },
        icon: '<i class="fa fa-edit"></i>',
      },
    ];


    const RowColumns = params?.node?.groupData;
    const RowColumnsId = params?.node?.id;

    const requiredColumns =  ["Warehouse", "OutletType"]
    const requiredColumnsWarehouseSKU =  ["Warehouse", "Product"]
    const requiredColumnsWarehouse= ["Warehouse"]
    const requiredColumnsPricelistSKU= ["Pricelist","Product"]
    const requiredColumnsWarehouseChannelSKU=["Warehouse", "OutletType","Product"]
    const requiredColumnsWarehouseChannelPricelistSKU=["Warehouse", "OutletType","Pricelist","Product"]
    

    const missingColumns = requiredColumns.filter(item => RowColumnsId.includes(item)).length;
    const missingColumnsWarehouse=requiredColumnsWarehouse.filter(item => RowColumnsId.includes(item)).length;
    const missingColumnsPricelist=requiredColumnsPricelistSKU.filter(item => RowColumnsId.includes(item)).length;
    const missingColumnsWarehouseChannelSKU=requiredColumnsWarehouseChannelSKU.filter(item => RowColumnsId.includes(item)).length;
    const missingWarehouseChannelPricelistSKU=requiredColumnsWarehouseChannelPricelistSKU.filter(item => RowColumnsId.includes(item)).length;
    const missingWarehouseSKU=requiredColumnsWarehouseSKU.filter(item => RowColumnsId.includes(item)).length;

    // // Check if there are any missing columns
    if(missingWarehouseChannelPricelistSKU===4){
      return [...defaultItems, "separator", ...CustomItemsWarehouseChannelPricelistSKU];
    }
    else if(missingColumnsWarehouseChannelSKU===3){
      return [...defaultItems, "separator", ...CustomItemsWarehouseChannelSKU];
    }
    else if(missingColumnsPricelist==2){
      return [...defaultItems, "separator", ...CustomItemsPricelistSKU];
    }
    else if (missingColumns===2 || missingWarehouseSKU===2) {
      return [...defaultItems, "separator", ...customItems];
    }else if(missingColumnsWarehouse===1){
      return [...defaultItems, "separator", ...CustomItemsWarehouse];
    }
    else {
      return [...defaultItems];
    }
  };

  useEffect(() => {
    if (gridRef.current && gridRef.current.columnApi) {
      gridRef.current.columnApi.setPivotColumns([
        "Country",
        "Warehouse",
        "OutletType",
        "Pricelist",
        "ProductCode",
      ]);
    }
  }, []);

  const updateRowData = (data) => {
    //console.log("updateRowData",data.length)
    if (data && data.length === 1) {
      if (gridRef.current) {
        const rowNode = gridRef.current.getRowNode(rowIndex);
        if (rowNode) {
          rowNode.setData(roundData(data[0]));
          gridRef.current.refreshClientSideRowModel("aggregate");
        } else {
          console.error("Row node not found for ID:", rowIndex);
        }
      }
    } else if (data?.length > 1) {
      data.forEach((d) => {
        const rowNode = allLeafChildren.find(
          (children) =>
            children.data.ProductCode === d.ProductCode &&
            children.data.Warehouse === d.Warehouse &&
            children.data.OutletType === d.OutletType &&
            children.data.Pricelist === d.Pricelist
        );
        if (rowNode) {
          rowNode.setData(roundData(d));
        } else {
          console.error("Row node not found for ID:", rowIndex);
        }
      });
      gridRef.current.refreshClientSideRowModel("aggregate");
    }
  };

  //adding new product in ag table
  const addRowDataForecastingProduct = (data) => {
    gridRef.current.applyTransaction({ add: data });
    gridRef.current.refreshClientSideRowModel("aggregate");
  };

  const getCurrentMonthDatesAsia = (date = dayjs()) => {
    const currentDate = dayjs();
    const startOfMonth = date.startOf("month").format("YYYY-MM-DD");
    const endOfMonth = date.endOf("month").format("YYYY-MM-DD");
    const daysInMonth = date.daysInMonth();
    const todayPlusTwoDay = currentDate.add(2, "day").format("DD");

    return {
      currentDate: currentDate.format("YYYY-MM-DD"),
      startOfMonth,
      endOfMonth,
      daysInMonth,
      todayPlusTwoDay,
    };
  };

  const handleCloseModal02 = () => {
    setNewSchemeModalOpen(false);
  };

  const onRowClicked = (event) => {
    setEditValue(null);
    setCallValue(null);
    const isPastMonth = monthYear.isBefore(dayjs(), "month");

    if (isPastMonth) {
      console.log("Cannot edit data for past months.");
      return;
    }

    setRowIndex(event?.node?.allLeafChildren["0"]?.sourceRowIndex);
    setAllLeafChildrens(event?.node?.allLeafChildren);
    setRowColumn(event?.source?.rowId);
    const RowColumns = event?.source?.rowId;
    const requiredColumns = ["Warehouse", "OutletType", "Product_Name"];

    const columnNameMap = {
      OutletType: "Channel",
      Product_Name: "Product name",
    };

    const missingColumns = requiredColumns.filter(
      (col) => !RowColumns.includes(col)
    );

    // Check if there are any missing columns
    const isValidClick = missingColumns.length === 0;

    if (!isValidClick) {
      console.log("Missing required columns. Click event will not proceed.");
      const missingColumnsMessage = missingColumns
        .map((col) => columnNameMap[col] || col)
        .join(", ");
      setSnackbarAlertMessage(
        `Missing required columns : ${missingColumnsMessage}.`
      );
      setSnackbarAlertSeverity("info");
      setSnackbarAlertOpen(true);
      return;
    }

    const clickedRowDataProductCode02 = event?.node?.allLeafChildren["0"]?.data;

    setCallValue(clickedRowDataProductCode02);
    openModalWithAGValues02(
      clickedRowDataProductCode02,
      getCurrentMonthDatesAsia(monthYear),
      setEditValue,
      RowColumns,
      "",
      "summary"
    );

    setCustomOpenModal(true);
  };

  const alertModelClose = () => {
    setAlertModalOpen(false);
    setCustomOpenModal(true);
  };

  const handleCancelClick = (shouldOpenNewSchemeModal = false) => {
    setUpdateLoading(true);
    setSaveLoading(true);

    const payload = {
      ...lineDataClick,
      page: "summary",
    };
    api
      .post("/deleteprocess", {
        body: payload,
      })
      .then((response) => {
        setSaveLoading(false);
        openModalWithAGValues02(
          callValue,
          getDatesFromMonthYearAsia(monthYear),
          setEditValue,
          rowColumn
        );
        updateRowData(response.data.data_updated);
        setCustomOpenModal(true);
        // setLoading(false);
        //console.error("correction canceled successfully:");
        setSnackbarAlertMessage("correction canceled successfully");
        setSnackbarAlertSeverity("success");
        setSnackbarAlertOpen(true);
      })
      .catch((error) => {
        console.error("Error canceling process:", error);
        setSnackbarAlertMessage("Failed to cancel correction");
        setSnackbarAlertSeverity("error");
        setSnackbarAlertOpen(true);
        setSaveLoading(false);
        setCustomOpenModal(true);
      })
      .finally(() => {
        setUpdateLoading(false);
        if (shouldOpenNewSchemeModal) {
          setCustomOpenModal(false);
          setNewSchemeModalOpen(true);
        }
      });
  };

  const handleCancelScheme = (rowType) => {
    setSaveLoading(true);
    setLoadingRowType(true);
    setLoadingButton(true);

    const requestBody = {
      ...lineDataClick,
      schemeType: rowType,
      page: "summary",
    };

    // setCustomOpenModal(false);
    api
      .post("/schemedeleteprocess", { body: requestBody })
      .then((response) => {
        setSaveLoading(false);
        openModalWithAGValues02(
          callValue,
          getDatesFromMonthYearAsia(monthYear),
          setEditValue,
          rowColumn
        );
        updateRowData(response.data.data_updated);
        setCustomOpenModal(true);
        setLoadingButton(false);
        console.log(`Successfully canceled scheme of type: ${rowType}`);
        setSnackbarAlertMessage(
          `Successfully canceled scheme of type: ${rowType || ""}`
        );
        setSnackbarAlertSeverity("success");
        setSnackbarAlertOpen(true);
      })
      .catch((error) => {
        console.error("Error canceling process:", error);
        setSnackbarAlertMessage(`Failed to cancel scheme of: ${rowType || ""}`);
        setSnackbarAlertSeverity("error");
        setSnackbarAlertOpen(true);
        setSaveLoading(false);
        setCustomOpenModal(true);
      })
      .finally(() => {
        setLoadingRowType(false);
      });
  };

  //edit permission
  useEffect(() => {
    const fetchPermission = async () => {
      const permissions = await fetchEditPermissions();
      setIsButtonEnabled(permissions.Current_Month === 1);
    };

    fetchPermission();
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarAlertOpen(false);
  };

  const handleOpenModal02 = () => {
    setIsModalOpen(true);
  };

  const onGridColumnsChanged = (event) => {
    const columnState = event?.api?.getColumnState();
    const colData = columnState
      ?.filter((col) => !col.rowGroup)
      .map((col) => ({ colId: col.colId, rowGroup: col.rowGroup }));
    if (gridRef) {
      const filterModel = event?.api?.getFilterModel();
      colData.map((col) => {
        delete filterModel[col?.colId]; // Remove filter for the hidden column
      });
      event?.api?.setFilterModel(filterModel);
    }
  };

  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [isWarehouseDisabled, setIsWarehouseDisabled] = useState(false);

  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState([]);
  const [isChannelDisabled, setIsChannelDisabled] = useState(false);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [isPriceListDisabled, setIsPriceListDisabled] = useState(false);

  const [priceLists, setPriceLists] = useState([]);
  const [selectedPriceList, setSelectedPriceList] = useState("");

  const [productNames, setProductNames] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [isProductDisabled, setIsProductDisabled] = useState(false);

  const [openNotification, setNotification] = useState(false);
  const [notificationText, setNotificationText] = useState("");

  const [isSchemeTypeDisabled, setIsSchemeTypeDisabled] = useState(false);
  const [selectedPriceListValue, setSelectedPriceListValue] = useState("");

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [multiModalErrors, setMultiModalErrors] = useState({});
  const [isSchemeMultiModalOpen, setIsSchemeMultiModalOpen] = useState(false);
  const [multiModalHeader, setMultiModalHeader] = useState("Create Multi-Warehouse Scheme");
  const [multiModalType, setMultiModalType] = useState("multi");
  const [multiModalFormData, setMultiModalFormData] = useState({
    schemeName: "",
    schemeStartDate: null,
    schemeEndDate: null,
    warehouse: [],
    channel: [],
    pricelist: [],
    productName: [],
    product: [],
    schemeType: "",
    rateImpact: "",
    quantityImpact: "",
    schemeImpactValue: "",
    mrpRate: "",
  });
  const resetMultiModalForm = () => {
    setMultiModalFormData({
      schemeName: "",
      schemeStartDate: null,
      schemeEndDate: null,
      warehouse: [],
      channel: [],
      pricelist: [],
      productName: [],
      productCode: [],
      schemeType: "",
      rateImpact: "",
      quantityImpact: "",
      schemeImpactValue: "",
      mrpRate: "",
    });
  };

  useEffect(() => {
    console.log("Updated multiModalFormData:", multiModalFormData);
  }, [multiModalFormData]);

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <LoadingSpinner />
          </div>
        </div>
      )}

      <div
        className="ag-table-container"
        style={{ marginLeft: open ? "240px" : "0px" }}
      >
        {/* {loading && <LoadingSpinner />} */}
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            paddingBottom: "20px",
            width: "100%",
            justifyContent: "flex-end",
          }}
          className="current-month-summary"
        >
          <MonthYearPicker value={monthYear} setValue={setMonthYear} />
          {/* <BasicSelect
            value={type}
            setValue={setType}
            name="Type"
            options={TYPES}
          /> */}
          <div>
            <Button
              variant="contained"
              disabled={!isButtonEnabled}
              onClick={handleOpenModal02}
              style={{
                fontSize: "12px",
                flexGrow: 1,
                // marginLeft: "8px",
                backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
                color: !isButtonEnabled ? "#9e9e9e" : "#fff",
                cursor: !isButtonEnabled ? "not-allowed" : "pointer",
                padding: "8px",
              }}
              color="primary"
              size="small"
            >
              <AddIcon
                sx={{
                  marginRight: "5px",
                }}
              />{" "}
              Add New Forecasting Product
            </Button>
          </div>

          {/* Clear Filters Button */}
          <div
            style={{
              transition:
                "opacity 0.4s ease-in-out, max-width 0.4s ease-in-out, margin 0.4s ease-in-out",
              opacity: hasActiveFilters ? 1 : 0,
              maxWidth: hasActiveFilters ? "150px" : "0px",
              overflow: "hidden",
              marginLeft: hasActiveFilters ? "10px" : "0px",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                if (gridRef.current) {
                  gridRef.current.setFilterModel(null);
                  gridRef.current.onFilterChanged();
                }
              }}
              style={{
                fontSize: "12px",
                color: "#000",
                borderColor: "#707070",
                whiteSpace: "nowrap",
                padding: "8px",
              }}
              size="small"
            >
              Clear Filters
            </Button>
          </div>
        </Box>
        <div
          className="ag-theme-quartz"
          style={{
            width: "100%",
            height: "calc(100dvh - 190px)",
            fontSize: "12px",
          }}
        >
          <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            pivotMode={true}
            sideBar={sideBar}
            autoGroupColumnDef={autoGroupColumnDef}
            grandTotalRow={"top"}
            suppressAggFuncInHeader={true}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
            groupDisplayType="multipleColumns"
            showOpenedGroup={true}
            groupHideOpenParents={true}
            groupDefaultExpanded={-1}
            groupSuppressAutoColumn={true}
            // getContextMenuItems={getContextMenuItems}
            onRowClicked={onRowClicked}
            alwaysShowHorizontalScroll={true}
            onGridColumnsChanged={onGridColumnsChanged}
            getContextMenuItems={getContextMenuItems}
          />
        </div>
      </div>

      {!monthYear.isBefore(dayjs(), "month") && (
        <EditModal
          open={customOpenModal}
          setCustomOpenModal={setCustomOpenModal}
          mode={mode}
          handleClose={closeModal}
          data={editingValue}
          editValue={editValue}
          callValue={callValue}
          monthYear={monthYear}
          updateRowData={updateRowData}
          rowColumn={rowColumn}
          setCallValue={setCallValue}
          modalName={"Edit Summary"}
          dayLevelButton={true}
          page={"summary"}
          initialCorrectionValue={initialCorrectionValue}
          setInitialCorrectionValue={setInitialCorrectionValue}
          setCurrentCorrectionValue={setCurrentCorrectionValue}
          currentCorrectionValue={currentCorrectionValue}
          handleOpenModal={handleOpenModal}
          closeModal={closeModal}
          baselineRateValue={baselineRateValue}
          setEditValue={setEditValue}
          handleCancelScheme={handleCancelScheme}
          loadingButton={loadingButton}
          handleCancelClick={handleCancelClick}
          updateLoading={updateLoading}
          setUpdateLoading={setUpdateLoading}
          loadingRowType={loadingRowType}
          setLoadingRowType={setLoadingRowType}
          clearModalFormData={clearModalFormData}
          setSnackbarAlertMessage={setSnackbarAlertMessage}
          setSnackbarAlertSeverity={setSnackbarAlertSeverity}
          setSnackbarAlertOpen={setSnackbarAlertOpen}
          setInitialTotalValue={setInitialTotalValue}
          initialTotalValue={initialTotalValue}
          setCurrentTotalValue={setCurrentTotalValue}
          currentTotalValue={currentTotalValue}
          handleOpenContinueModal={handleOpenContinueModal}
        />
      )}

      <AddNewScheme
        newSchemeModalOpen={newSchemeModalOpen}
        handleCloseModal02={handleCloseModal02}
        callValue={callValue}
        rowColumn={rowColumn}
        editValue={editValue}
        setEditValue={setEditValue}
        schemeTypeData={schemeTypeData}
        setCallValue={setCallValue}
        setCustomOpenModal={setCustomOpenModal}
        monthYear={monthYear}
        handleClose={closeModal}
        page={"summary"}
        updateRowData={updateRowData}
        modalformData={modalformData}
        modalsetFormData={modalsetFormData}
        schemeContinue={schemeContinue}
      />
      <AlertModal
        alertModalOpen={alertModalOpen}
        // handleClose={closeAlertModal}
        alertModelClose={alertModelClose}
        handleCancelScheme={handleCancelScheme}
        handleCancelClick={handleCancelClick}
        message={
          "You cannot create or modify the scheme for this product due to an existing correction value. To proceed, please delete the correction value by clicking 'Yes'."
        }
      />

      {/* <AddNewProductModal
        modalTitle="Add New Forecasting Product"
        isModalOpen={isModalOpen}
        shouldDisableDate={true}
        setIsModalOpen={setIsModalOpen}
        qtyLabel={"Qty Per Day"}
        warehouseMulti={false}
        channelMulti={false}
        priceListMulti={false}
      /> */}

      <AddNewForecasting
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        addRowDataForecastingProduct={addRowDataForecastingProduct}
      />
      <CreateSchemeMultiWarehouse
        open={isSchemeMultiModalOpen}
        modalHeader={multiModalHeader}
        modalType={multiModalType}
        setModalOpen={setIsSchemeMultiModalOpen}
        warehouses={warehouses}
        setWarehouses={setWarehouses}
        selectedWarehouse={selectedWarehouse}
        setSelectedWarehouse={setSelectedWarehouse}
        isWarehouseDisabled={isWarehouseDisabled}
        channels={channels}
        setChannels={setChannels}
        selectedChannel={selectedChannel}
        setSelectedChannel={setSelectedChannel}
        isChannelDisabled={isChannelDisabled}
        categories={categories}
        setCategories={setCategories}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        isPriceListDisabled={isPriceListDisabled}
        priceLists={priceLists}
        setPriceLists={setPriceLists}
        selectedPriceList={selectedPriceList}
        setSelectedPriceList={setSelectedPriceList}
        productNames={productNames}
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        setSelectedProductCode={setSelectedProduct}
        isProductDisabled={isProductDisabled}
        openNotification={openNotification}
        setNotification={setNotification}
        setNotificationText={setNotificationText}
        isSchemeTypeDisabled={isSchemeTypeDisabled}
        selectedPriceListValue={selectedPriceListValue}
        setSelectedPriceListValue={setSelectedPriceListValue}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarOpen={setSnackbarOpen}
        modalFormData={multiModalFormData}
        setModalFormData={setMultiModalFormData}
        resetForm={resetMultiModalForm}
        errors={multiModalErrors}
        setErrors={setMultiModalErrors}
        updateRowData={updateRowData}
        defaultStartDate={monthYear.startOf("month").format("YYYY-MM-DD")}
        defaultEndDate={monthYear.endOf("month").format("YYYY-MM-DD")}
        minStartDate={dayjs().add(2, 'day').format("YYYY-MM-DD")}
        
      />

      <Snackbar
        open={snackbarAlertOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={SnackbarAlertSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarAlertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CurrentMonthSummary;
